<template>
    <div v-if="limitFiles" class="col-12 px-5">
        <div class="alert alert-danger">Por favor añada un solo archivo</div>
    </div>
    <div id="dropzone_CSV">
        <div class="dropzone-container" @dragover="dragover" @dragleave="dragleave" @drop="drop">
            <input type="file" multiple name="file" id="fileInput" class="hidden-input" @change="onChange" ref="file"
                accept=".csv,.xlsx" />

            <label for="fileInput" class="file-label">
                <div v-if="isDragging">Suelta para insertar archivo</div>
                <div v-else>Arrastre el archivo aqui o <u>haz click aqui</u> para añadir.</div>
            </label>
            <div class="d-flex justify-content-center preview-container mt-4" v-if="files.length">
                <div v-for="file in files" :key="file.name" class="preview-card">
                    <div class="position-relative">
                        <button type="button" class="close" @click="remove(files.indexOf(file))" aria-label="Delete">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <v-icon name="bi-filetype-csv" scale="3.5" />
                        <p class="fileName">
                            {{ file.name }}
                        </p>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="d-flex align-items-center justify-content-center mt-4">
        <a v-if="!$store.state.roles.Backoffice_member_empresas" href="/assets/cargaImeiEjemplo.csv" download>
            <v-icon name="bi-download" scale="1.1" /> Descargar CSV de ejemplo
        </a>
        <a v-if="$store.state.roles.Backoffice_member_empresas" href="/assets/cargaImeiEjemploEmpresa.csv" download>
            <v-icon name="bi-download" scale="1.1" /> Descargar CSV de ejemplo
        </a>
    </div>
    <div class="row mt-3 pt-3 pl-0">
        <div class="col-12">
            <button id="closeButton" class="btn generalSecondaryButton float-left" data-dismiss="modal">Cerrar</button>
            <button v-if="$store.state.roles.Backoffice_member_empresas" class="btn btn-primary generalPrimaryButton float-right" @click="uploadFiles(contractId)"
                :disabled="files.length < 1">
                <img v-if="loading" src="../../../../../assets/loader.svg" height="20" alt="">
                <span v-else>Enviar</span>
            </button>
            <button v-else class="btn btn-primary generalPrimaryButton float-right" @click="uploadFiles()"
                :disabled="files.length < 1">
                <img v-if="loading" src="../../../../../assets/loader.svg" height="20" alt="">
                <span v-else>Enviar</span>
            </button>
        </div>
    </div>
</template>

<script>
import axios from 'axios'; 

export default {
    data() {
        return {
            isDragging: false,
            files: [],
            limitFiles: false,
            loading: false,
            modelConfig: {
                type: 'string',
                mask: 'DD/MM/YYYY',
            },
        };
    },
    props: [
        'contractId'
    ],
    methods: {
        onChange() {
            this.files = [...this.$refs.file.files];
            console.log(this.files);
            let promise = new Promise((resolve, reject) => {
                var reader = new FileReader();
                reader.onload = e => {
                    resolve(reader.result)
                    console.log(e)
                };
                reader.onerror = e => {
                    reject(e)
                }
                reader.readAsText(this.files[0])
            })

            promise.then(result => console.log(result), error => console.log(error))
        },
        dragover(e) {
            e.preventDefault();
            this.isDragging = true;
        },
        dragleave() {
            this.isDragging = false;
        },
        drop(e) {
            e.preventDefault();
            console.log(e.dataTransfer.files.length)
            if (e.dataTransfer.files.length < 2) {
                this.$refs.file.files = e.dataTransfer.files;
                this.onChange();
                this.limitFiles = false
            } else {
                this.limitFiles = true;
            }
            this.isDragging = false;
        },
        remove(i) {
            this.files.splice(i, 1);
        },
        uploadFiles(contract) {
            this.loading = true;
            const files = this.files;
            const formData = new FormData();
            const vm = this;
            if (this.$store.state.roles.Backoffice_member_empresas) {                
                files.forEach((file) => {
                    formData.append("csv", file);
                });
                axios.patch(`/business/${contract}/callback-imei`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    }
                }).then((response) => {
                    console.log(response);
                    document.getElementById('closeButton').click();
                    vm.$emit('loadSuccessModal');
                    this.loading = false;
                }).catch((error) => {
                    document.getElementById('closeButton').click();
                    vm.$emit('loadErrorModal', error);
                    this.loading = false;
                });
            }else{
                files.forEach((file) => {
                    formData.append("file", file);
                });
                formData.append('backOfficeUser', this.$cookies.get('username'));
                axios.post(`/logistics-tracking/csv-upload`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
                }).then((response) => {
                    console.log(response);
                    document.getElementById('closeButton').click();
                    vm.$emit('loadSuccessModal');
                    this.loading = false;
                }).catch((error) => {
                    document.getElementById('closeButton').click();
                    vm.$emit('loadErrorModal', error);
                    this.loading = false;
                });
            }
        },
    },
};
</script>
<style scope lang="scss">
#dropzone_CSV {
    display: flex;
    flex-grow: 1;
    align-items: center;
    min-height: 13vh;
    justify-content: center;
    text-align: center;
}

.dropzone-container {
    padding: 5rem;
    width: 45rem;
    max-height: 20vh;
    background: #f7fafc;
    border: 1px solid #e2e8f0;
}

.hidden-input {
    opacity: 0;
    overflow: hidden;
    position: absolute;
    width: 1px;
    height: 1px;
}

.file-label {
    font-size: 20px;
    display: block;
    cursor: pointer;
}

.preview-container {
    display: flex;
    margin-top: 2rem;
}

.preview-card {
    display: flex;
    padding: 5px;
    margin-left: 5px;
}

.preview-container {
    .close {
        font-size: 2.5rem;
        line-height: 0.4;
        font-weight: normal;
        position: absolute;
        top: 0;
        right: -12px;
    }

    .fileName {
        max-width: 100px;
        max-height: 45px;
        text-overflow: ellipsis;
        overflow: hidden;
    }
}
</style>